import React, { useMemo } from 'react';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { Select } from 'antd';

const { Option, OptGroup } = Select;

// Pinned above the region groups: it's the system default and has no "Region/" prefix, so
// it would otherwise land in a one-item group of its own.
const PINNED = 'UTC';
// Zones without a "Region/" prefix (CET, EST5EDT, Japan, ...) share one group.
const OTHER_GROUP = 'Other';

export default function TimezonePicker(props) {
  const options = useMemo(() => {
    const timezones = moment.tz.names();
    const mappedValues = {};
    const regions = [];

    timezones.forEach((timezone) => {
      if (timezone === PINNED) return;
      const region = timezone.includes('/')
        ? timezone.split('/')[0]
        : OTHER_GROUP;
      if (!(region in mappedValues)) {
        mappedValues[region] = [];
        regions.push(region);
      }
      mappedValues[region].push(timezone);
    });

    const groups = regions.map((region) => {
      const options = mappedValues[region].map((timezone) => {
        return <Option key={timezone}>{timezone}</Option>;
      });
      return (
        <OptGroup key={region} label={region} title={region}>
          {options}
        </OptGroup>
      );
    });
    return [<Option key={PINNED}>{PINNED}</Option>, ...groups];
  }, []);

  return (
    <Select showSearch defaultValue={momentTimezone.tz.guess()} {...props}>
      {options}
    </Select>
  );
}
